import { theme } from 'theme'

export const userProfileSVG = (
  <svg width="20" height="27" viewBox="0 0 14 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="7.00031" cy="4.03156" r="4.00031" fill={theme.colors.primary} />
    <ellipse cx="6.99956" cy="15.0325" rx="7.00054" ry="4.00031" fill={theme.colors.primary} />
  </svg>
)
